import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=3d4eb3e2&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=3d4eb3e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4eb3e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4eb3e2')) {
      api.createRecord('3d4eb3e2', component.options)
    } else {
      api.reload('3d4eb3e2', component.options)
    }
    module.hot.accept("./GoodsInfo.vue?vue&type=template&id=3d4eb3e2&scoped=true", function () {
      api.rerender('3d4eb3e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore2/steps/GoodsInfo.vue"
export default component.exports